import React, { useEffect, useState } from "react";
import { Grid, CircularProgress, Box } from '@mui/material';
import { getSingleOrgSeasonApi} from '../../api/orgSeasonApi';
import { useParams } from 'react-router-dom';
import { ErrorHeader } from "../../shared/errorHeader";
import { OrgSeason } from "../../api/models/orgSeason";
import { ManageLogoPanel } from "./manageLogoPanel";
import { ManageNamePanel } from "./manageNamePanel";
import { OrgSeasonContext } from "../../context/orgSeasonContext";
import { BasicBackButton } from "../../shared/basicBackButton";
import { LoginHeader } from "../../shared/loginHeader";
import { CardEditPanel } from "./cardEditPanel";
import { Team } from "../../api/models/team";
import { useAuth0 } from "@auth0/auth0-react";
import { useAppUser } from "../../providers/appUserContext";
import { useApiCallWithAuth } from "../../hooks/useApiCallWithAuth";


export function TeamAdminPage() {

    const [orgSeason, setOrgSeason] = useState<OrgSeason | undefined>(undefined);
    const [selectedTeam, setSelectedTeam] = useState<Team | undefined>(undefined);
    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const params = useParams();

    const { isAuthenticated } = useAuth0();
    const { appUser, getPermission, isAdmin, refreshAppUser } = useAppUser();

    const getOrgSeasonApiRequest = useApiCallWithAuth(getSingleOrgSeasonApi);

    useEffect(() => {
        if (!params.orgSeasonGuid) {
            throw Error('OrgSeason Guid is missing');
        }

        if (!params.teamGuid) {
            throw Error('Team Guid is missing');
        }

        console.log(`isAuthenticated: ${isAuthenticated}, isAdmin: ${isAdmin(params.orgSeasonGuid)}`);

        if (!isAuthenticated || !isAdmin(params.orgSeasonGuid)) {
            setErrorMessage('You do not have permission to access this page X');
            return;
        }

        initPage();
    }, [isAuthenticated, isAdmin, params.orgSeasonGuid]);

   

    //verify param for orgSeason id exist and request user role for this org
    async function initPage() {

        await refreshOrgSeason();
    }

    async function refreshOrgSeason() {

        setIsLoading(true);

        try{
            const orgSeasonData = await getOrgSeasonApiRequest.request(params.orgSeasonGuid);
            setOrgSeason(orgSeasonData);

            const tempTeam = orgSeasonData.teams.find((team: Team) => team.id === params.teamGuid);
            setSelectedTeam(tempTeam);

        } catch (error:any) {
            setErrorMessage(`Failed to load organization season: ${error.message}`);
        } finally {
            setIsLoading(false);
        }

    }

    

    function mainContent() {

        return (
            <OrgSeasonContext.Provider value={{ orgSeason, refreshOrgSeason }}>

                <Box sx={{ width: 600 }}>
                    <Grid item container spacing={1} direction='column' justifyContent="flex-start">
                        <Grid item>
                            <Grid item container spacing={2} justifyContent="flex-start" alignItems="center" >
                                <Grid item><h1>{selectedTeam?.name} Admin Page</h1></Grid>
                            </Grid>
                        </Grid>

                        {selectedTeam && <Grid item container spacing={2} direction='column'>

                            <Grid item>
                                <ManageNamePanel team={selectedTeam} />
                            </Grid>

                            <Grid item>
                                <ManageLogoPanel team={selectedTeam} />
                            </Grid>

                            <Grid item>
                                <CardEditPanel team={selectedTeam} />
                            </Grid>
                        </Grid>}

                    </Grid>
                </Box>
            </OrgSeasonContext.Provider>
        );
    }

    return (<Box>
        <LoginHeader />
        <Box>{orgSeason && <BasicBackButton labelText='' navigateUrl={`/orgseason/${orgSeason.id}`} />}</Box>
        <ErrorHeader errorMessage={errorMessage} />
        {isLoading && <CircularProgress />}
        {orgSeason && mainContent()}
    </Box>
    );

}